import {toZonedTime, format} from "date-fns-tz";
import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';

export const maskAccountNumber = (accoundNumber) => {
  const accountNumLength = accoundNumber?.length;
  if (accountNumLength < 9) {
    let maskedAccount = accoundNumber;
    for (let i = 0; i < accountNumLength; i++) {
      maskedAccount = maskedAccount.replace(accoundNumber[i], "*");
    }
    return maskedAccount;
  } else return accoundNumber;
};

export const maskedAccountId = (accoundNumber) => {
  if (accoundNumber && accoundNumber.length > 4) {
    return "*".repeat(accoundNumber.length - 4) + accoundNumber.slice(-4);
  }
  return accoundNumber;
  /* const accountNumLength = accoundNumber?.length;
    if(accoundNumber && accountNumLength === 10){
        const maskedLength = accountNumLength - 4;
        let newAccountNum = accoundNumber;
        for(let i = 0; i < accountNumLength; i++ )
        {
            if(i < maskedLength){
                newAccountNum = newAccountNum.replace(accoundNumber[i], '*');
            }
        }
        return newAccountNum;
    }
    else return; */
};

export const maskSSNNumber = (ssnNumber) => {
  if (ssnNumber) {
    return ssnNumber.replace(/./g, "*");
  }
  //const ssnNumLength = ssnNumber.length;
  /* if(ssnNumber){
        let maskedSSN = ssnNumber;
        for(let i = 0; i < ssnNumLength; i++ ){
            maskedSSN = maskedSSN.replace(ssnNumber[i], '*');
        }
        return maskedSSN;
    } */
  //return ssnNumber;
};

export const formatNumber = (tele_number) => {
  /*const number_length = tele_number.length
    if(number_length === 3 || number_length === 7){
        tele_number = tele_number + "-"
    }
    return tele_number*/
  tele_number = tele_number.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3");
  return tele_number;
};

export const downloadToExcel = (exportData, filename) => {
  const link = document.createElement("a");
  let csv = convertArrayOfObjectsToCSV(exportData);
  if (csv == null) return;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute("href", encodeURI(csv));
  link.setAttribute("download", filename);
  link.click();
};

function convertArrayOfObjectsToCSV(array) {
  let result;
  const columnDelimiter = ",";
  const lineDelimiter = "\n";
  const keys = Object.keys(array[0]);
  let columns = keys.map(key => 
    (key.charAt(0).toUpperCase() + key.slice(1)).replace(/([a-z])([A-Z])/g, '$1 $2'));

  result = "";
  result += columns.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach((item) => {
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;
      result += item[key];
      // eslint-disable-next-line no-plusplus
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

export const getUTCUpdatedAtDateForLog=(updatedAt)=>{
     
     const date =new Date(updatedAt);
     const month = String(date.getUTCMonth()+1).padStart(2, '0');
     const day = String(date.getUTCDate()).padStart(2, '0');
     const year = date.getUTCFullYear();
     const hours = String(date.getUTCHours()).padStart(2, '0');
     const minutes = String(date.getUTCMinutes()).padStart(2, '0');
     const seconds = String(date.getUTCSeconds()).padStart(2, '0');
     const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');
    //pattern = "yyyy-MM-dd HH:mm:ss.SSS"
     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}

 export const caseInsensitiveSort =(rowA, rowB, columnSelector) => {
 	const a = columnSelector(rowA).toLowerCase();
 	const b = columnSelector(rowB).toLowerCase();
 	if(a < b) return -1;
        if(a > b) return 1;
       return 0;
};

 export const convertFromUTCToEST =(updatedAtDate) =>{
  const timeZone = "America/New_York";
  const date = new Date(updatedAtDate);
   const zonedDate = toZonedTime(date, timeZone);
   const formattedDte = format(zonedDate, "yyyy-MM-dd HH:mm:ss", {timeZone: 'America/New_York'});
   return formattedDte;
 }

 export const getESTYear =()=> {
  const now = new Date();
  const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
  const estOffset = -5; // EST is UTC-5
  const estTime = new Date(utc + (3600000 * estOffset));
  return estTime.getFullYear();
}

export const sortInAlphabeticalOrder = (filteredList) => {
  const compNameList = filteredList.map(item => ({...item, companyName: item.companyName.toUpperCase()}))
  .sort((a,b) => a.companyName.localeCompare(b.companyName));
  return compNameList;
}

export const getDefaultCareFacility =(carefacilityDetails) =>{
      for(const obj of carefacilityDetails){
        if(obj.defaultCareFacilityId > 0){
          return obj
        }
      }
      return null;
    }

const filterData =(data, headers, carefacility)=>{
        return data && data.map((row)=>{
            const filteredRow={};
            headers.forEach(col=>{
                if(row.hasOwnProperty(col.key)){
                    if(col.key === "accountNumber"){
                        filteredRow[col.key] = maskedAccountId(row[col.key]);
                    }
                    if(col.key ==="careFacilityName"){
                        filteredRow[col.key]= carefacility && Object.keys(carefacility).length>0 ?  carefacility.careFacilityName : row[col.key];
                    }
                    else {
                        filteredRow[col.key] = row[col.key]
                    }
                }
            });
            return filteredRow;
        })
    }

  export const exportToExcel= async (headers, data, filename, carefacility) =>{
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1') ;
        worksheet.columns = headers;
        const filteredData = filterData(data, headers, carefacility);

        filteredData.forEach((item)=>{
         worksheet.addRow(item);
        });
 
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        saveAs(blob, filename);
    }

export const sortIntegerValues =(rowA, rowB, columnSelector) =>{
          const a = columnSelector(rowA);
          const b = columnSelector(rowB);
          	if(a < b) return -1;
            if(a > b) return 1;
            return 0;
}

export const getFormattedDate =(inputDate)=>{
    const date =new Date(inputDate);
    const month = String(date.getUTCMonth()+1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = date.getUTCFullYear();
   
    return `${month}-${day}-${year}`;
  }